import moment, { Moment } from 'moment';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import { Tooltip } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faUserEdit } from '@fortawesome/free-solid-svg-icons';

type Props = {
  isReserveForTheMoment: boolean;
  editedWithDriverAssigned?: boolean;
  schedule: {
    arrival: Moment;
    exit: Moment;
    end: Moment;
  };
  priceDriver: string;
  /** Oculta la fecha (DD/MM) cuando es el día de hoy */
  hideDateIfToday?: boolean;
};

export const ViajeTrasladoPendienteTableTimesCell = ({
  isReserveForTheMoment,
  editedWithDriverAssigned,
  schedule,
  priceDriver,
  hideDateIfToday = false
}: Props) => {
  const hasStatusIcon = isReserveForTheMoment || editedWithDriverAssigned;
  const showExitDate =
    !hideDateIfToday || !moment(schedule?.exit).isSame(moment(), 'day');
  const showArrivalDate =
    !hideDateIfToday || !moment(schedule?.arrival).isSame(moment(), 'day');
  const fechaDeReservaPosteriorALaFechaActual = moment(
    schedule?.arrival
  ).isBefore(moment());
  const fechaDeSalidaPosteriorALaFechaActual = moment(schedule?.exit).isBefore(
    moment()
  );
  const fechaDeReservaEsMañana =
    moment(schedule?.arrival).format('YYYY-MM-DD') ===
    moment().add(1, 'day').format('YYYY-MM-DD');

  return (
    <div
      className="grid w-32 grid-cols-2 items-center text-xs"
      style={{ columnGap: '1.5vw' }}
    >
      <Tooltip title="Salida de chofer" arrow placement="top" className="ml-2">
        <div className="title col-span-1 mb-1 flex gap-0 items-center">
          <span
            className={
              fechaDeSalidaPosteriorALaFechaActual ? 'text-red-500' : ''
            }
          >
            {moment(schedule.exit).format('HH:mm')}
          </span>
          <QueryBuilderIcon
            fontSize="small"
            className={
              fechaDeSalidaPosteriorALaFechaActual
                ? 'text-red-500'
                : 'text-gray-400'
            }
          />
        </div>
      </Tooltip>
      <span
        className={
          'col-span-1 text-xs text-gray-400 ' +
          (fechaDeSalidaPosteriorALaFechaActual ? 'text-red-500' : '') +
          ' mb-1'
        }
        title="Salida de chofer"
      >
        {showExitDate ? moment(schedule.exit).format('DD/MM') : null}
      </span>
      <span
        className={
          'title col-span-1 font-bold ml-2 ' +
          (fechaDeReservaEsMañana
            ? 'text-green-500'
            : fechaDeReservaPosteriorALaFechaActual
            ? 'text-red-500'
            : '')
        }
        style={{ fontSize: 16 }}
        title="Llegada a origen"
      >
        {moment(schedule.arrival).format('HH:mm')}
      </span>
      <span
        className={
          'col-span-1 text-xs font-bold ' +
          (fechaDeReservaEsMañana
            ? 'text-green-500'
            : fechaDeReservaPosteriorALaFechaActual
            ? 'text-red-500'
            : 'text-gray-700')
        }
        style={{ fontSize: 13 }}
        title="Llegada a origen"
      >
        {showArrivalDate ? moment(schedule.arrival).format('DD/MM') : null}
      </span>
      <span
        className={`${hasStatusIcon? 'col-span-1': 'col-span-2'} title mt-1 text-inkMuted dark:text-inkMuted-dark ml-2 whitespace-nowrap`}
        title="Llegada a destino"
      >
        {Math.abs(moment(schedule.end).diff(schedule.arrival, 'minutes'))} min.
      </span>
       {hasStatusIcon && (
            <span className="title col-span-1 mt-1 ml-2 flex gap-1">
              {isReserveForTheMoment && (
                <Tooltip title="Es reserva para el momento" arrow placement="top">
                  <div
                    className={` flex justify-center items-center rounded-3xl p-1 w-5 h-5`}
                    style={{
                      backgroundColor: '#ff0000'
                    }}
                  >
                    <FontAwesomeIcon icon={faBolt} color="#f0ff00" className="" />
                  </div>
                </Tooltip>
              )}
              {editedWithDriverAssigned && (
                <Tooltip
                  title="Modificada por el usuario con chofer asignado"
                  arrow
                  placement="top"
                >
                  <div
                    className={` flex justify-center items-center rounded-3xl p-1 w-5 h-5`}
                    style={{
                      backgroundColor: '#ff9800'
                    }}
                  >
                    <FontAwesomeIcon icon={faUserEdit} color="#ffffff" className="" />
                  </div>
                </Tooltip>
              )}
            </span>)}
      <div className="mt-1 py-1 px-1 ml-2 w-fit rounded-lg bg-white text-xs text-gray-500 border-2 border-gray-200">
        <p>{priceDriver}</p>
      </div>
    </div>
  );
};
